import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Gala extends Lit3formBlock {
  static get characterName() {
    return 'gala';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid gala-layout">
          <p class="eyebrow">${this.driverData('eyebrow')}</p>
          <h1 class="header">${this.driverData('header')}</h1>
          <p class="description">
            ${this.driverData('description')}
          </p>
          ${this.ctaHTML}
          <div class="driver-image">
            <img src=${this.imageUrl()} />
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  driverData(param) {
    return unsafeHTML(this.withLineBreaks(this.content[param])) || '';
  }

  imageUrl() {
    return this.imagebossUrl(this.image.src, 1200, null);
  }

  hasCta() {
    return this.content.cta && typeof this.content.cta === 'object';
  }

  get ctaInfo() {
    const url = this.content.cta.url || '';
    const text = this.content.cta.text || '';
    return JSON.stringify({ url, text });
  }

  get ctaHTML() {
    return this.hasCta
      ? html`
          <cta-button
            class="cta-btn details-row"
            cta-data=${this.ctaInfo}
            cta-type="primary"
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaInfo,
              this.driverData('header')
            )}
          ></cta-button>
        `
      : ``;
  }

  get image() {
    return this.content.image || {};
  }
}
Gala.defineElement();
